import {
  Companion_getInstance21u335vgn0mpe as Companion_getInstance,
  User8yb1tqk4kykg as User,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  EmailAddress1n0o8cqqfp9qz as EmailAddress,
  PhoneNumber2x98iurnwvnj9 as PhoneNumber,
} from '../../../lightning-server-shared/com/lightningkite/StringAlts.mjs';
import {
  Addresscpovxna1tjmg as Address,
  UserMembership38xnkdta6uihl as UserMembership,
} from './supportModels.mjs';
import {
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
  UUID21wrnrlmk5y1y as UUID,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { UserRole18rzbkqbyt5er as UserRole } from './enums.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_firstName(_this__u8e3s4) {
  return _this__u8e3s4.prop(User_firstName_getInstance());
}
function get_lastName(_this__u8e3s4) {
  return _this__u8e3s4.prop(User_lastName_getInstance());
}
function get_sendNotifications(_this__u8e3s4) {
  return _this__u8e3s4.prop(User_sendNotifications_getInstance());
}
function get_mfaEnabled(_this__u8e3s4) {
  return _this__u8e3s4.prop(User_mfaEnabled_getInstance());
}
function get_viewingAnonymousProjects(_this__u8e3s4) {
  return _this__u8e3s4.prop(User_viewingAnonymousProjects_getInstance());
}
function get_email(_this__u8e3s4) {
  return _this__u8e3s4.prop(User_email_getInstance());
}
function get_phoneNumber(_this__u8e3s4) {
  return _this__u8e3s4.prop(User_phoneNumber_getInstance());
}
function get_address(_this__u8e3s4) {
  return _this__u8e3s4.prop(User_address_getInstance());
}
function get_membership(_this__u8e3s4) {
  return _this__u8e3s4.prop(User_membership_getInstance());
}
function prepareUserFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [User__id_getInstance(), User_email_getInstance(), User_phoneNumber_getInstance(), User_fcmTokens_getInstance(), User_firstName_getInstance(), User_lastName_getInstance(), User_address_getInstance(), User_membership_getInstance(), User_paymentId_getInstance(), User_role_getInstance(), User_receivesNewContractorEmails_getInstance(), User_mfaEnabled_getInstance(), User_phoneVerified_getInstance(), User_hasPaymentMethods_getInstance(), User_sendNotifications_getInstance(), User_viewingAnonymousProjects_getInstance(), User_created_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function User_firstName$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(4);
}
function User_firstName$_get_name_$ref_z3l3d8() {
  return (p0) => p0.i20();
}
function User_firstName$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function User_firstName$_get_serializer_$ref_25dy3f() {
  return (p0) => p0.h2j();
}
function User_firstName$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(4);
}
function User_firstName$_get_annotations_$ref_bpldhd() {
  return (p0) => p0.bz();
}
var User_firstNameClass;
function User_firstName() {
  if (User_firstNameClass === VOID) {
    class $ {
      constructor() {
        User_firstName_instance = this;
        var tmp = this;
        tmp.z87_1 = lazy(User_firstName$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a88_1 = lazy(User_firstName$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b88_1 = lazy(User_firstName$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.z87_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, User_firstName$_get_name_$ref_z3l3d8(), null);
        return tmp0.f2();
      }
      c88(receiver) {
        return receiver.h88_1;
      }
      k2j(receiver) {
        return this.c88(receiver instanceof User() ? receiver : THROW_CCE());
      }
      u88(receiver, value) {
        return receiver.v88(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof User() ? receiver : THROW_CCE();
        return this.u88(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.a88_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, User_firstName$_get_serializer_$ref_25dy3f(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b88_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, User_firstName$_get_annotations_$ref_bpldhd(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'User_firstName', VOID, VOID, [SerializableProperty()]);
    User_firstNameClass = $;
  }
  return User_firstNameClass;
}
var User_firstName_instance;
function User_firstName_getInstance() {
  if (User_firstName_instance === VOID)
    new (User_firstName())();
  return User_firstName_instance;
}
function User_lastName$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(5);
}
function User_lastName$_get_name_$ref_w7vqm6() {
  return (p0) => p0.i20();
}
function User_lastName$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function User_lastName$_get_serializer_$ref_ots36x() {
  return (p0) => p0.h2j();
}
function User_lastName$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(5);
}
function User_lastName$_get_annotations_$ref_4en7qr() {
  return (p0) => p0.bz();
}
var User_lastNameClass;
function User_lastName() {
  if (User_lastNameClass === VOID) {
    class $ {
      constructor() {
        User_lastName_instance = this;
        var tmp = this;
        tmp.w88_1 = lazy(User_lastName$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x88_1 = lazy(User_lastName$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y88_1 = lazy(User_lastName$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.w88_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, User_lastName$_get_name_$ref_w7vqm6(), null);
        return tmp0.f2();
      }
      c88(receiver) {
        return receiver.i88_1;
      }
      k2j(receiver) {
        return this.c88(receiver instanceof User() ? receiver : THROW_CCE());
      }
      u88(receiver, value) {
        return receiver.v88(VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof User() ? receiver : THROW_CCE();
        return this.u88(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.x88_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, User_lastName$_get_serializer_$ref_ots36x(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y88_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, User_lastName$_get_annotations_$ref_4en7qr(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'User_lastName', VOID, VOID, [SerializableProperty()]);
    User_lastNameClass = $;
  }
  return User_lastNameClass;
}
var User_lastName_instance;
function User_lastName_getInstance() {
  if (User_lastName_instance === VOID)
    new (User_lastName())();
  return User_lastName_instance;
}
function User_sendNotifications$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(14);
}
function User_sendNotifications$_get_name_$ref_diqx4p() {
  return (p0) => p0.i20();
}
function User_sendNotifications$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[14];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function User_sendNotifications$_get_serializer_$ref_5o6n4w() {
  return (p0) => p0.h2j();
}
function User_sendNotifications$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(14);
}
function User_sendNotifications$_get_annotations_$ref_l5x678() {
  return (p0) => p0.bz();
}
var User_sendNotificationsClass;
function User_sendNotifications() {
  if (User_sendNotificationsClass === VOID) {
    class $ {
      constructor() {
        User_sendNotifications_instance = this;
        var tmp = this;
        tmp.z88_1 = lazy(User_sendNotifications$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a89_1 = lazy(User_sendNotifications$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b89_1 = lazy(User_sendNotifications$annotations$delegate$lambda);
        this.c89_1 = true;
        this.d89_1 = 'true';
      }
      i20() {
        var tmp0 = this.z88_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, User_sendNotifications$_get_name_$ref_diqx4p(), null);
        return tmp0.f2();
      }
      c88(receiver) {
        return receiver.r88_1;
      }
      k2j(receiver) {
        return this.c88(receiver instanceof User() ? receiver : THROW_CCE());
      }
      e89(receiver, value) {
        return receiver.v88(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof User() ? receiver : THROW_CCE();
        return this.e89(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.a89_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, User_sendNotifications$_get_serializer_$ref_5o6n4w(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b89_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, User_sendNotifications$_get_annotations_$ref_l5x678(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'User_sendNotifications', VOID, VOID, [SerializableProperty()]);
    User_sendNotificationsClass = $;
  }
  return User_sendNotificationsClass;
}
var User_sendNotifications_instance;
function User_sendNotifications_getInstance() {
  if (User_sendNotifications_instance === VOID)
    new (User_sendNotifications())();
  return User_sendNotifications_instance;
}
function User_mfaEnabled$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(11);
}
function User_mfaEnabled$_get_name_$ref_7838ue() {
  return (p0) => p0.i20();
}
function User_mfaEnabled$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[11];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function User_mfaEnabled$_get_serializer_$ref_9nvdnj() {
  return (p0) => p0.h2j();
}
function User_mfaEnabled$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(11);
}
function User_mfaEnabled$_get_annotations_$ref_o4j5n() {
  return (p0) => p0.bz();
}
var User_mfaEnabledClass;
function User_mfaEnabled() {
  if (User_mfaEnabledClass === VOID) {
    class $ {
      constructor() {
        User_mfaEnabled_instance = this;
        var tmp = this;
        tmp.f89_1 = lazy(User_mfaEnabled$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g89_1 = lazy(User_mfaEnabled$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h89_1 = lazy(User_mfaEnabled$annotations$delegate$lambda);
        this.i89_1 = false;
        this.j89_1 = 'false';
      }
      i20() {
        var tmp0 = this.f89_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, User_mfaEnabled$_get_name_$ref_7838ue(), null);
        return tmp0.f2();
      }
      c88(receiver) {
        return receiver.o88_1;
      }
      k2j(receiver) {
        return this.c88(receiver instanceof User() ? receiver : THROW_CCE());
      }
      e89(receiver, value) {
        return receiver.v88(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof User() ? receiver : THROW_CCE();
        return this.e89(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.g89_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, User_mfaEnabled$_get_serializer_$ref_9nvdnj(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h89_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, User_mfaEnabled$_get_annotations_$ref_o4j5n(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'User_mfaEnabled', VOID, VOID, [SerializableProperty()]);
    User_mfaEnabledClass = $;
  }
  return User_mfaEnabledClass;
}
var User_mfaEnabled_instance;
function User_mfaEnabled_getInstance() {
  if (User_mfaEnabled_instance === VOID)
    new (User_mfaEnabled())();
  return User_mfaEnabled_instance;
}
function User_viewingAnonymousProjects$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(15);
}
function User_viewingAnonymousProjects$_get_name_$ref_2e02t1() {
  return (p0) => p0.i20();
}
function User_viewingAnonymousProjects$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[15];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function User_viewingAnonymousProjects$_get_serializer_$ref_x8ms0e() {
  return (p0) => p0.h2j();
}
function User_viewingAnonymousProjects$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(15);
}
function User_viewingAnonymousProjects$_get_annotations_$ref_jwca5y() {
  return (p0) => p0.bz();
}
var User_viewingAnonymousProjectsClass;
function User_viewingAnonymousProjects() {
  if (User_viewingAnonymousProjectsClass === VOID) {
    class $ {
      constructor() {
        User_viewingAnonymousProjects_instance = this;
        var tmp = this;
        tmp.k89_1 = lazy(User_viewingAnonymousProjects$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l89_1 = lazy(User_viewingAnonymousProjects$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m89_1 = lazy(User_viewingAnonymousProjects$annotations$delegate$lambda);
        this.n89_1 = emptyList();
        this.o89_1 = 'emptyList()';
      }
      i20() {
        var tmp0 = this.k89_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, User_viewingAnonymousProjects$_get_name_$ref_2e02t1(), null);
        return tmp0.f2();
      }
      c88(receiver) {
        return receiver.s88_1;
      }
      k2j(receiver) {
        return this.c88(receiver instanceof User() ? receiver : THROW_CCE());
      }
      p89(receiver, value) {
        return receiver.v88(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof User() ? receiver : THROW_CCE();
        return this.p89(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.l89_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, User_viewingAnonymousProjects$_get_serializer_$ref_x8ms0e(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m89_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, User_viewingAnonymousProjects$_get_annotations_$ref_jwca5y(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'User_viewingAnonymousProjects', VOID, VOID, [SerializableProperty()]);
    User_viewingAnonymousProjectsClass = $;
  }
  return User_viewingAnonymousProjectsClass;
}
var User_viewingAnonymousProjects_instance;
function User_viewingAnonymousProjects_getInstance() {
  if (User_viewingAnonymousProjects_instance === VOID)
    new (User_viewingAnonymousProjects())();
  return User_viewingAnonymousProjects_instance;
}
function User_email$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function User_email$_get_name_$ref_7p10r9() {
  return (p0) => p0.i20();
}
function User_email$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function User_email$_get_serializer_$ref_ttqc1o() {
  return (p0) => p0.h2j();
}
function User_email$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function User_email$_get_annotations_$ref_hawq9s() {
  return (p0) => p0.bz();
}
var User_emailClass;
function User_email() {
  if (User_emailClass === VOID) {
    class $ {
      constructor() {
        User_email_instance = this;
        var tmp = this;
        tmp.q89_1 = lazy(User_email$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r89_1 = lazy(User_email$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s89_1 = lazy(User_email$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.q89_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, User_email$_get_name_$ref_7p10r9(), null);
        return tmp0.f2();
      }
      t89(receiver) {
        return receiver.e88_1;
      }
      k2j(receiver) {
        return new (EmailAddress())(this.t89(receiver instanceof User() ? receiver : THROW_CCE()));
      }
      u89(receiver, value) {
        return receiver.v88(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof User() ? receiver : THROW_CCE();
        return this.u89(tmp, value instanceof EmailAddress() ? value.a3n_1 : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.r89_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, User_email$_get_serializer_$ref_ttqc1o(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s89_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, User_email$_get_annotations_$ref_hawq9s(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'User_email', VOID, VOID, [SerializableProperty()]);
    User_emailClass = $;
  }
  return User_emailClass;
}
var User_email_instance;
function User_email_getInstance() {
  if (User_email_instance === VOID)
    new (User_email())();
  return User_email_instance;
}
function User_phoneNumber$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function User_phoneNumber$_get_name_$ref_bgl8hc() {
  return (p0) => p0.i20();
}
function User_phoneNumber$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function User_phoneNumber$_get_serializer_$ref_wem8x5() {
  return (p0) => p0.h2j();
}
function User_phoneNumber$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function User_phoneNumber$_get_annotations_$ref_5y45mt() {
  return (p0) => p0.bz();
}
var User_phoneNumberClass;
function User_phoneNumber() {
  if (User_phoneNumberClass === VOID) {
    class $ {
      constructor() {
        User_phoneNumber_instance = this;
        var tmp = this;
        tmp.v89_1 = lazy(User_phoneNumber$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w89_1 = lazy(User_phoneNumber$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x89_1 = lazy(User_phoneNumber$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.v89_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, User_phoneNumber$_get_name_$ref_bgl8hc(), null);
        return tmp0.f2();
      }
      y89(receiver) {
        return receiver.f88_1;
      }
      k2j(receiver) {
        return new (PhoneNumber())(this.y89(receiver instanceof User() ? receiver : THROW_CCE()));
      }
      z89(receiver, value) {
        return receiver.v88(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof User() ? receiver : THROW_CCE();
        return this.z89(tmp, value instanceof PhoneNumber() ? value.f3n_1 : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.w89_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, User_phoneNumber$_get_serializer_$ref_wem8x5(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x89_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, User_phoneNumber$_get_annotations_$ref_5y45mt(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'User_phoneNumber', VOID, VOID, [SerializableProperty()]);
    User_phoneNumberClass = $;
  }
  return User_phoneNumberClass;
}
var User_phoneNumber_instance;
function User_phoneNumber_getInstance() {
  if (User_phoneNumber_instance === VOID)
    new (User_phoneNumber())();
  return User_phoneNumber_instance;
}
function User_address$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(6);
}
function User_address$_get_name_$ref_7lc783() {
  return (p0) => p0.i20();
}
function User_address$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function User_address$_get_serializer_$ref_6q09bg() {
  return (p0) => p0.h2j();
}
function User_address$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(6);
}
function User_address$_get_annotations_$ref_kst7l4() {
  return (p0) => p0.bz();
}
var User_addressClass;
function User_address() {
  if (User_addressClass === VOID) {
    class $ {
      constructor() {
        User_address_instance = this;
        var tmp = this;
        tmp.a8a_1 = lazy(User_address$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b8a_1 = lazy(User_address$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c8a_1 = lazy(User_address$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.a8a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, User_address$_get_name_$ref_7lc783(), null);
        return tmp0.f2();
      }
      c88(receiver) {
        return receiver.j88_1;
      }
      k2j(receiver) {
        return this.c88(receiver instanceof User() ? receiver : THROW_CCE());
      }
      d8a(receiver, value) {
        return receiver.v88(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof User() ? receiver : THROW_CCE();
        return this.d8a(tmp, value instanceof Address() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.b8a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, User_address$_get_serializer_$ref_6q09bg(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c8a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, User_address$_get_annotations_$ref_kst7l4(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'User_address', VOID, VOID, [SerializableProperty()]);
    User_addressClass = $;
  }
  return User_addressClass;
}
var User_address_instance;
function User_address_getInstance() {
  if (User_address_instance === VOID)
    new (User_address())();
  return User_address_instance;
}
function User_membership$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(7);
}
function User_membership$_get_name_$ref_dpgthl() {
  return (p0) => p0.i20();
}
function User_membership$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function User_membership$_get_serializer_$ref_gth0gu() {
  return (p0) => p0.h2j();
}
function User_membership$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(7);
}
function User_membership$_get_annotations_$ref_urjysi() {
  return (p0) => p0.bz();
}
var User_membershipClass;
function User_membership() {
  if (User_membershipClass === VOID) {
    class $ {
      constructor() {
        User_membership_instance = this;
        var tmp = this;
        tmp.e8a_1 = lazy(User_membership$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f8a_1 = lazy(User_membership$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g8a_1 = lazy(User_membership$annotations$delegate$lambda);
        this.h8a_1 = null;
        this.i8a_1 = 'null';
      }
      i20() {
        var tmp0 = this.e8a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, User_membership$_get_name_$ref_dpgthl(), null);
        return tmp0.f2();
      }
      c88(receiver) {
        return receiver.k88_1;
      }
      k2j(receiver) {
        return this.c88(receiver instanceof User() ? receiver : THROW_CCE());
      }
      j8a(receiver, value) {
        return receiver.v88(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof User() ? receiver : THROW_CCE();
        return this.j8a(tmp, (value == null ? true : value instanceof UserMembership()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.f8a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, User_membership$_get_serializer_$ref_gth0gu(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g8a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, User_membership$_get_annotations_$ref_urjysi(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'User_membership', VOID, VOID, [SerializableProperty()]);
    User_membershipClass = $;
  }
  return User_membershipClass;
}
var User_membership_instance;
function User_membership_getInstance() {
  if (User_membership_instance === VOID)
    new (User_membership())();
  return User_membership_instance;
}
function User__id$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function User__id$_get_name_$ref_6gcooj() {
  return (p0) => p0.i20();
}
function User__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function User__id$_get_serializer_$ref_j9h0pm() {
  return (p0) => p0.h2j();
}
function User__id$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function User__id$_get_annotations_$ref_q0nt7i() {
  return (p0) => p0.bz();
}
var User__idClass;
function User__id() {
  if (User__idClass === VOID) {
    class $ {
      constructor() {
        User__id_instance = this;
        var tmp = this;
        tmp.k8a_1 = lazy(User__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l8a_1 = lazy(User__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m8a_1 = lazy(User__id$annotations$delegate$lambda);
        this.n8a_1 = Companion_getInstance_0().k2p();
        this.o8a_1 = 'UUID.random()';
      }
      i20() {
        var tmp0 = this.k8a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, User__id$_get_name_$ref_6gcooj(), null);
        return tmp0.f2();
      }
      c88(receiver) {
        return receiver.d88_1;
      }
      k2j(receiver) {
        return this.c88(receiver instanceof User() ? receiver : THROW_CCE());
      }
      p8a(receiver, value) {
        return receiver.v88(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof User() ? receiver : THROW_CCE();
        return this.p8a(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.l8a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, User__id$_get_serializer_$ref_j9h0pm(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m8a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, User__id$_get_annotations_$ref_q0nt7i(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'User__id', VOID, VOID, [SerializableProperty()]);
    User__idClass = $;
  }
  return User__idClass;
}
var User__id_instance;
function User__id_getInstance() {
  if (User__id_instance === VOID)
    new (User__id())();
  return User__id_instance;
}
function User_fcmTokens$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(3);
}
function User_fcmTokens$_get_name_$ref_70d22l() {
  return (p0) => p0.i20();
}
function User_fcmTokens$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function User_fcmTokens$_get_serializer_$ref_8j9dey() {
  return (p0) => p0.h2j();
}
function User_fcmTokens$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(3);
}
function User_fcmTokens$_get_annotations_$ref_3folim() {
  return (p0) => p0.bz();
}
var User_fcmTokensClass;
function User_fcmTokens() {
  if (User_fcmTokensClass === VOID) {
    class $ {
      constructor() {
        User_fcmTokens_instance = this;
        var tmp = this;
        tmp.q8a_1 = lazy(User_fcmTokens$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r8a_1 = lazy(User_fcmTokens$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s8a_1 = lazy(User_fcmTokens$annotations$delegate$lambda);
        this.t8a_1 = emptyList();
        this.u8a_1 = 'emptyList()';
      }
      i20() {
        var tmp0 = this.q8a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, User_fcmTokens$_get_name_$ref_70d22l(), null);
        return tmp0.f2();
      }
      c88(receiver) {
        return receiver.g88_1;
      }
      k2j(receiver) {
        return this.c88(receiver instanceof User() ? receiver : THROW_CCE());
      }
      v8a(receiver, value) {
        return receiver.v88(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof User() ? receiver : THROW_CCE();
        return this.v8a(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.r8a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, User_fcmTokens$_get_serializer_$ref_8j9dey(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s8a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, User_fcmTokens$_get_annotations_$ref_3folim(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'User_fcmTokens', VOID, VOID, [SerializableProperty()]);
    User_fcmTokensClass = $;
  }
  return User_fcmTokensClass;
}
var User_fcmTokens_instance;
function User_fcmTokens_getInstance() {
  if (User_fcmTokens_instance === VOID)
    new (User_fcmTokens())();
  return User_fcmTokens_instance;
}
function User_paymentId$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(8);
}
function User_paymentId$_get_name_$ref_6v16fu() {
  return (p0) => p0.i20();
}
function User_paymentId$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function User_paymentId$_get_serializer_$ref_7k2utb() {
  return (p0) => p0.h2j();
}
function User_paymentId$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(8);
}
function User_paymentId$_get_annotations_$ref_53fasl() {
  return (p0) => p0.bz();
}
var User_paymentIdClass;
function User_paymentId() {
  if (User_paymentIdClass === VOID) {
    class $ {
      constructor() {
        User_paymentId_instance = this;
        var tmp = this;
        tmp.w8a_1 = lazy(User_paymentId$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x8a_1 = lazy(User_paymentId$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y8a_1 = lazy(User_paymentId$annotations$delegate$lambda);
        this.z8a_1 = null;
        this.a8b_1 = 'null';
      }
      i20() {
        var tmp0 = this.w8a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, User_paymentId$_get_name_$ref_6v16fu(), null);
        return tmp0.f2();
      }
      c88(receiver) {
        return receiver.l88_1;
      }
      k2j(receiver) {
        return this.c88(receiver instanceof User() ? receiver : THROW_CCE());
      }
      b8b(receiver, value) {
        return receiver.v88(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof User() ? receiver : THROW_CCE();
        return this.b8b(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.x8a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, User_paymentId$_get_serializer_$ref_7k2utb(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y8a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, User_paymentId$_get_annotations_$ref_53fasl(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'User_paymentId', VOID, VOID, [SerializableProperty()]);
    User_paymentIdClass = $;
  }
  return User_paymentIdClass;
}
var User_paymentId_instance;
function User_paymentId_getInstance() {
  if (User_paymentId_instance === VOID)
    new (User_paymentId())();
  return User_paymentId_instance;
}
function User_role$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(9);
}
function User_role$_get_name_$ref_i2x2l3() {
  return (p0) => p0.i20();
}
function User_role$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function User_role$_get_serializer_$ref_p52y82() {
  return (p0) => p0.h2j();
}
function User_role$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(9);
}
function User_role$_get_annotations_$ref_i2e7b2() {
  return (p0) => p0.bz();
}
var User_roleClass;
function User_role() {
  if (User_roleClass === VOID) {
    class $ {
      constructor() {
        User_role_instance = this;
        var tmp = this;
        tmp.c8b_1 = lazy(User_role$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d8b_1 = lazy(User_role$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e8b_1 = lazy(User_role$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.c8b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, User_role$_get_name_$ref_i2x2l3(), null);
        return tmp0.f2();
      }
      c88(receiver) {
        return receiver.m88_1;
      }
      k2j(receiver) {
        return this.c88(receiver instanceof User() ? receiver : THROW_CCE());
      }
      f8b(receiver, value) {
        return receiver.v88(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof User() ? receiver : THROW_CCE();
        return this.f8b(tmp, value instanceof UserRole() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.d8b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, User_role$_get_serializer_$ref_p52y82(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e8b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, User_role$_get_annotations_$ref_i2e7b2(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'User_role', VOID, VOID, [SerializableProperty()]);
    User_roleClass = $;
  }
  return User_roleClass;
}
var User_role_instance;
function User_role_getInstance() {
  if (User_role_instance === VOID)
    new (User_role())();
  return User_role_instance;
}
function User_receivesNewContractorEmails$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(10);
}
function User_receivesNewContractorEmails$_get_name_$ref_22dj8r() {
  return (p0) => p0.i20();
}
function User_receivesNewContractorEmails$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[10];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function User_receivesNewContractorEmails$_get_serializer_$ref_50vn7o() {
  return (p0) => p0.h2j();
}
function User_receivesNewContractorEmails$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(10);
}
function User_receivesNewContractorEmails$_get_annotations_$ref_2eo6v4() {
  return (p0) => p0.bz();
}
var User_receivesNewContractorEmailsClass;
function User_receivesNewContractorEmails() {
  if (User_receivesNewContractorEmailsClass === VOID) {
    class $ {
      constructor() {
        User_receivesNewContractorEmails_instance = this;
        var tmp = this;
        tmp.g8b_1 = lazy(User_receivesNewContractorEmails$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h8b_1 = lazy(User_receivesNewContractorEmails$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i8b_1 = lazy(User_receivesNewContractorEmails$annotations$delegate$lambda);
        this.j8b_1 = false;
        this.k8b_1 = 'false';
      }
      i20() {
        var tmp0 = this.g8b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, User_receivesNewContractorEmails$_get_name_$ref_22dj8r(), null);
        return tmp0.f2();
      }
      c88(receiver) {
        return receiver.n88_1;
      }
      k2j(receiver) {
        return this.c88(receiver instanceof User() ? receiver : THROW_CCE());
      }
      e89(receiver, value) {
        return receiver.v88(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof User() ? receiver : THROW_CCE();
        return this.e89(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.h8b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, User_receivesNewContractorEmails$_get_serializer_$ref_50vn7o(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i8b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, User_receivesNewContractorEmails$_get_annotations_$ref_2eo6v4(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'User_receivesNewContractorEmails', VOID, VOID, [SerializableProperty()]);
    User_receivesNewContractorEmailsClass = $;
  }
  return User_receivesNewContractorEmailsClass;
}
var User_receivesNewContractorEmails_instance;
function User_receivesNewContractorEmails_getInstance() {
  if (User_receivesNewContractorEmails_instance === VOID)
    new (User_receivesNewContractorEmails())();
  return User_receivesNewContractorEmails_instance;
}
function User_phoneVerified$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(12);
}
function User_phoneVerified$_get_name_$ref_7r0c9b() {
  return (p0) => p0.i20();
}
function User_phoneVerified$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[12];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function User_phoneVerified$_get_serializer_$ref_cl9clm() {
  return (p0) => p0.h2j();
}
function User_phoneVerified$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(12);
}
function User_phoneVerified$_get_annotations_$ref_j1si7u() {
  return (p0) => p0.bz();
}
var User_phoneVerifiedClass;
function User_phoneVerified() {
  if (User_phoneVerifiedClass === VOID) {
    class $ {
      constructor() {
        User_phoneVerified_instance = this;
        var tmp = this;
        tmp.l8b_1 = lazy(User_phoneVerified$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m8b_1 = lazy(User_phoneVerified$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n8b_1 = lazy(User_phoneVerified$annotations$delegate$lambda);
        this.o8b_1 = false;
        this.p8b_1 = 'false';
      }
      i20() {
        var tmp0 = this.l8b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, User_phoneVerified$_get_name_$ref_7r0c9b(), null);
        return tmp0.f2();
      }
      c88(receiver) {
        return receiver.p88_1;
      }
      k2j(receiver) {
        return this.c88(receiver instanceof User() ? receiver : THROW_CCE());
      }
      e89(receiver, value) {
        return receiver.v88(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof User() ? receiver : THROW_CCE();
        return this.e89(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.m8b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, User_phoneVerified$_get_serializer_$ref_cl9clm(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n8b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, User_phoneVerified$_get_annotations_$ref_j1si7u(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'User_phoneVerified', VOID, VOID, [SerializableProperty()]);
    User_phoneVerifiedClass = $;
  }
  return User_phoneVerifiedClass;
}
var User_phoneVerified_instance;
function User_phoneVerified_getInstance() {
  if (User_phoneVerified_instance === VOID)
    new (User_phoneVerified())();
  return User_phoneVerified_instance;
}
function User_hasPaymentMethods$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(13);
}
function User_hasPaymentMethods$_get_name_$ref_b81rgh() {
  return (p0) => p0.i20();
}
function User_hasPaymentMethods$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[13];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function User_hasPaymentMethods$_get_serializer_$ref_otrs86() {
  return (p0) => p0.h2j();
}
function User_hasPaymentMethods$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(13);
}
function User_hasPaymentMethods$_get_annotations_$ref_4edrti() {
  return (p0) => p0.bz();
}
var User_hasPaymentMethodsClass;
function User_hasPaymentMethods() {
  if (User_hasPaymentMethodsClass === VOID) {
    class $ {
      constructor() {
        User_hasPaymentMethods_instance = this;
        var tmp = this;
        tmp.q8b_1 = lazy(User_hasPaymentMethods$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r8b_1 = lazy(User_hasPaymentMethods$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s8b_1 = lazy(User_hasPaymentMethods$annotations$delegate$lambda);
        this.t8b_1 = false;
        this.u8b_1 = 'false';
      }
      i20() {
        var tmp0 = this.q8b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, User_hasPaymentMethods$_get_name_$ref_b81rgh(), null);
        return tmp0.f2();
      }
      c88(receiver) {
        return receiver.q88_1;
      }
      k2j(receiver) {
        return this.c88(receiver instanceof User() ? receiver : THROW_CCE());
      }
      e89(receiver, value) {
        return receiver.v88(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof User() ? receiver : THROW_CCE();
        return this.e89(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.r8b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, User_hasPaymentMethods$_get_serializer_$ref_otrs86(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s8b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, User_hasPaymentMethods$_get_annotations_$ref_4edrti(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'User_hasPaymentMethods', VOID, VOID, [SerializableProperty()]);
    User_hasPaymentMethodsClass = $;
  }
  return User_hasPaymentMethodsClass;
}
var User_hasPaymentMethods_instance;
function User_hasPaymentMethods_getInstance() {
  if (User_hasPaymentMethods_instance === VOID)
    new (User_hasPaymentMethods())();
  return User_hasPaymentMethods_instance;
}
function User_created$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(16);
}
function User_created$_get_name_$ref_15x0bl() {
  return (p0) => p0.i20();
}
function User_created$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[16];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function User_created$_get_serializer_$ref_bsb6pk() {
  return (p0) => p0.h2j();
}
function User_created$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(16);
}
function User_created$_get_annotations_$ref_5vmkdw() {
  return (p0) => p0.bz();
}
var User_createdClass;
function User_created() {
  if (User_createdClass === VOID) {
    class $ {
      constructor() {
        User_created_instance = this;
        var tmp = this;
        tmp.v8b_1 = lazy(User_created$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w8b_1 = lazy(User_created$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x8b_1 = lazy(User_created$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.y8b_1 = get_default(Companion_instance).b1m();
        this.z8b_1 = 'now()';
      }
      i20() {
        var tmp0 = this.v8b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, User_created$_get_name_$ref_15x0bl(), null);
        return tmp0.f2();
      }
      c88(receiver) {
        return receiver.t88_1;
      }
      k2j(receiver) {
        return this.c88(receiver instanceof User() ? receiver : THROW_CCE());
      }
      a8c(receiver, value) {
        return receiver.v88(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof User() ? receiver : THROW_CCE();
        return this.a8c(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.w8b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, User_created$_get_serializer_$ref_bsb6pk(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x8b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, User_created$_get_annotations_$ref_5vmkdw(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'User_created', VOID, VOID, [SerializableProperty()]);
    User_createdClass = $;
  }
  return User_createdClass;
}
var User_created_instance;
function User_created_getInstance() {
  if (User_created_instance === VOID)
    new (User_created())();
  return User_created_instance;
}
//region block: exports
export {
  get_address as get_addressm9hct5lany5j,
  get_email as get_emailn9rmxjmv5jjf,
  get_firstName as get_firstName2tft79c8on6bn,
  get_lastName as get_lastName7sdqgimj4byz,
  get_membership as get_membership2p5yrn2d458jx,
  get_mfaEnabled as get_mfaEnabled1lbzuse6gxxu1,
  get_phoneNumber as get_phoneNumberwyjkikct2tk8,
  prepareUserFields as prepareUserFields1dplnl5p8nrb0,
  get_sendNotifications as get_sendNotifications3liu60yge341n,
  get_viewingAnonymousProjects as get_viewingAnonymousProjects1fofp0ylcs0e6,
};
//endregion

//# sourceMappingURL=UserFields.mjs.map
